import { SpecialtyModel } from '@/modules/schedule/domain/models/SpecialtyModel'

import { axios, Response } from '../index'

export const getSpecialties = (): Response<SpecialtyModel> => {
  return axios.get(`/v1/specialties`)
}
